import {
  dimensiondata_1_tevekenyseg_group_dimension_1_2_3_4_first_row_expanded_w200,
  dimensiondata_1_tevekenyseg_group_dimension_1_first_row_expanded,
  dimensiondata_2_termekek_group_1_2_3_4_first_column_expanded,
  dimensiondata_2_termekek_group_first_column_expanded,
  TJ_value_1_data_precision,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const iparVegsoConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {numberOfYears: 1},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/IparVegso',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tevekenyseg_group_dimension_1_2_3_4_first_row_expanded_w200,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_1_2_3_4_first_column_expanded,
      TJ_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
